<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { Col } from 'ant-design-vue/es/grid/'

const SearchList = {
  name: 'SearchList',
  components: {
    Col
  },
  inject: {
    col: {
      type: Number
    },
    buttonCol: {
      type: Number
    }
  },
  render() {

    return (
      < a-row> {
        this.$slots.default && this.$slots.default.map((item, index, arr) => {
          return (
            < Col {...{ props: responsive[(this.buttonCol > 0 && (this.$slots.default.length - 1) === index) ? this.buttonCol : this.col] }}>{item}</Col>)
        })
      } < /a-row>)
  }
}

const responsive = {
  1: { xs: 24 },
  2: { xs: 24, sm: 12 },
  3: { xs: 24, sm: 12, md: 8 },
  4: { xs: 24, sm: 12, md: 6 }
}
export default {
  name: 'SearchHeader',
  SearchList: SearchList,
  props: {
    buttonCol: {
      type: Number,
      required: false,
      default: 0
    },
    col: {
      type: Number,
      required: false,
      default: 3
    }

  },
  provide() {
    return {
      col: this.col > 4 ? 4 : this.col, buttonCol: this.buttonCol > 4 ? 4 : this.buttonCol
    }
  }
}
</script>